import { observer } from "mobx-react-lite";
import React from "react";
import { batchOverviewGridStyles } from "./BatchOverviewGridStyles";
import { BatchOverviewGridProps } from "./BatchOverviewGridProps";
import { Grid, Typography } from "@material-ui/core";

export default observer(function BatchOverviewGrid({
    data,
    gridXS,
}: BatchOverviewGridProps) {
    const classes = batchOverviewGridStyles();

    return (
        <Grid className={classes.grid} container justifyContent="space-between">
            {data.map((information) => (
                <Grid xs={gridXS} key={information.subTitle}>
                    <span className={classes.title}>
                        {information.subTitle}
                    </span>
                    <Typography className={classes.text}>
                        {information.item}
                    </Typography>
                    {information.enteredText && (
                        <Typography className={classes.text}>
                            {information.enteredText}
                        </Typography>
                    )}
                </Grid>
            ))}
        </Grid>
    );
});
